import {
  List
} from 'immutable';

import { METIERSDEVIS_FETCH } from '../constants/ActionTypes';

const initialState = new List();
export default (state = initialState, action) => {
  switch (action.type) {
    case METIERSDEVIS_FETCH: {
      return action.payload;
    }
    default:
      return state;
  }
};
